import { HFConfig } from '../config';
import { Messages } from './translate';

export function translations({ baseUrl, language }: HFConfig) {
  return fetch(`${baseUrl}/assets/locales/messages_${language}.json`).then((response) => response.json()) as Promise<Messages>;
}
